import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { BreakAllocationRule } from "@/actions/ssr/settings/getBreakAllocationRulesSSR";

interface BreakAllocationState {
  rules: BreakAllocationRule[];
}

const initialState: BreakAllocationState = {
  rules: [],
};

const breakAllocationSlice = createSlice({
  name: "breakAllocation",
  initialState,
  reducers: {
    setBreakAllocationRules(
      state,
      action: PayloadAction<BreakAllocationRule[]>,
    ) {
      state.rules = action.payload;
    },
  },
});

export const { setBreakAllocationRules } = breakAllocationSlice.actions;
export default breakAllocationSlice.reducer;
